import { Navigate, generatePath } from "react-router-dom"
import { CleaningTourPage } from "../pages/PhotoTourPage"
import { NewShiftPage } from "../pages/NewShiftPage"
import { ShiftPage } from "../pages/ShiftPage"
import { WeeklyAchievementPage } from "../pages/WeeklyAchievementPage"
import { AchievementDetailPage } from "@/pages/AchievementDetailPage"
import { CleaningInfoPage } from "@/pages/CleaningInfoPage"
import { CleaningReportPage } from "@/pages/CleaningReportPage"
import { OperationInfoPage } from "@/pages/OperationInfoPage"
import { OperationReportPage } from "@/pages/OperationReportPage"
import { SchedulePage } from "@/pages/SchedulePage"
import { SubmitShiftPage } from "@/pages/SubmitShiftPage"
import { UnreportedSchedulePage } from "@/pages/UnreportedSchedulePage"
import ApprovalRequestListPage from "@/pages/ApprovalRequestListPage"
import ApprovalRequestDetailPage from "@/pages/ApprovalRequestDetailPage"
import { TroubleReportPage } from "@/pages/TroubleReportPage"
import { LostItemPage } from "@/pages/CleaningReportPage/LostItemPage"
import { LanguageSettingsPage } from "@/pages/LanguageSettingsPage"
import { RankDashboardPage } from "@/pages/RankDashboardPage"
import { TransportationExpensePage } from "@/pages/TransportationExpensePage"
import { NewTransportationExpensePage } from "@/pages/NewTransportationExpensePage"
import { MatsuriCleanerGuard } from "@/components/MatsuriCleanerGuard"
import { featureFlags } from "@/utils/featureFlags"

const CLEANING_REPORTS_PAGE = "/reports/:cleaningId/*"
const OPERATION_REPORTS_PAGE = "/reports/operations/:operationId/*"

export const genCleaningReportPagePath = (
    cleaningId: string,
    nestedPath?: string
) => {
    return generatePath(CLEANING_REPORTS_PAGE, {
        cleaningId,
        "*": nestedPath ?? ""
    })
}

export const genOperationReportPagePath = (
    operationId: string,
    nestedPath?: string
) => {
    return generatePath(OPERATION_REPORTS_PAGE, {
        operationId,
        "*": nestedPath ?? ""
    })
}

const CLEANING_TOUR_PAGE = "/tour/:cleaningId/*"

export const genCleaningTourPagePath = (
    cleaningId: string,
    nestedPath?: string
) => {
    return generatePath(CLEANING_TOUR_PAGE, {
        cleaningId,
        "*": nestedPath ?? ""
    })
}

const CLEANING_INFO_PAGE = "/cleanings/:cleaningId/*"

export const genCleaningInfoPagePath = (
    cleaningId: string,
    nestedPath?: string
) => {
    return generatePath(CLEANING_INFO_PAGE, {
        cleaningId,
        "*": nestedPath ?? ""
    })
}

const OPERATION_INFO_PAGE = "/operations/:operationId/*"

export const genOperationInfoPagePath = (
    operationId: string,
    nestedPath?: string
) => {
    return generatePath(OPERATION_INFO_PAGE, {
        operationId,
        "*": nestedPath ?? ""
    })
}

export const protectedRoutes = [
    {
        path: "/schedule",
        element: <SchedulePage />
    },
    {
        path: "/schedule/unreported",
        element: <UnreportedSchedulePage />
    },
    {
        path: "/cleanings/:cleaningId/trouble",
        element: <TroubleReportPage />
    },
    {
        // 清掃詳細から単独で開く忘れ物報告。完了報告フロー内の同画面とは
        // 離脱先が異なるため standalone で開く。
        path: "/cleanings/:cleaningId/lost-items",
        element: <LostItemPage mode="standalone" />
    },
    {
        path: "/cleanings/:cleaningId/*",
        element: <CleaningInfoPage />
    },
    {
        path: CLEANING_REPORTS_PAGE,
        element: <CleaningReportPage />
    },
    {
        path: CLEANING_TOUR_PAGE,
        element: <CleaningTourPage />
    },
    {
        path: OPERATION_REPORTS_PAGE,
        element: <OperationReportPage />
    },
    {
        path: "/operations/:operationId/*",
        element: <OperationInfoPage />
    },
    {
        path: "/shift",
        element: <ShiftPage />
    },
    {
        path: "/shift/new",
        element: <NewShiftPage />
    },
    {
        path: "/shift/submit",
        element: <SubmitShiftPage />
    },
    {
        path: "/*",
        element: <Navigate to="/schedule" />
    },
    {
        path: "/achievements/weekly",
        element: <WeeklyAchievementPage />
    },
    {
        path: "/achievements/:date",
        element: <AchievementDetailPage />
    },
    {
        path: "/approval_requests",
        element: <ApprovalRequestListPage />
    },
    {
        path: "/approval_requests/:approvalRequestId",
        element: <ApprovalRequestDetailPage />
    },
    {
        path: "/settings/language",
        element: <LanguageSettingsPage />
    },
    {
        path: "/rank-dashboard",
        element: <RankDashboardPage />
    },
    ...(featureFlags.transportationExpense
        ? [
              {
                  path: "/transportation_expenses",
                  element: (
                      <MatsuriCleanerGuard>
                          <TransportationExpensePage />
                      </MatsuriCleanerGuard>
                  )
              },
              {
                  path: "/transportation_expenses/new",
                  element: (
                      <MatsuriCleanerGuard>
                          <NewTransportationExpensePage />
                      </MatsuriCleanerGuard>
                  )
              }
          ]
        : [])
]
